/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';

// URLs are configured in Constants/endpoints.js (INTERNAL_LOGS_CONFIG / INTERNAL_LOGS),
// built from BASE_URL = `${ORIGIN}/server.storeDash/v2.1`. The Main server is that ORIGIN;
// other server blocks insert their suffix into the first hostname label
// (e.g. bakingo.resoee.com -> bakingo-ops.resoee.com). withServerSuffix rewrites the
// origin of the canonical endpoint URL for non-main blocks.
function withServerSuffix(url, suffix = '') {
	if (!suffix) return url;
	try {
		const u = new URL(url);
		const labels = u.hostname.split('.');
		labels[0] = `${labels[0]}${suffix}`;
		u.hostname = labels.join('.');
		return u.toString();
	} catch (e) {
		return url;
	}
}

function post(url, body) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify(body || {}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

function fetchLogConfig() {
	return post(endpoints.INTERNAL_LOGS_CONFIG);
}

function logAction(suffix, body) {
	return post(withServerSuffix(endpoints.INTERNAL_LOGS, suffix), body);
}

const internalLogsServices = {
	fetchLogConfig,
	logAction,
};

export default internalLogsServices;
